import { jsx as _jsx } from "react/jsx-runtime";
import { Navigate } from 'react-router-dom';
import { useMount } from 'react-use';
import { languages } from 'app/utils/supportedLanguages';
import { CustomizationPage } from './CustomizationPage';
export const CustomizationPageRoute = (props) => {
    useMount(() => {
        props.loadEmailSettingsAllLevels();
    });
    const { language: languageCode, settingsId } = props.params;
    const { mode } = props;
    if (!languageCode || !mode) {
        throw new Error(`${CustomizationPageRoute.name} expects to have router params to have the "languageCode" field.
         It must be used as a direct Route component. exp: <Route component={${CustomizationPageRoute.name}}/>`);
    }
    const language = languages.find(({ code }) => code === (languageCode === null || languageCode === void 0 ? void 0 : languageCode.toLocaleLowerCase()));
    if (!language) {
        return _jsx(Navigate, { to: "/settings/satisfaction/email" });
    }
    return (_jsx(CustomizationPage, Object.assign({ languageName: language.label || '', settingsId: settingsId, mode: mode }, props)));
};
